import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import ContentLayout from '@/layouts/ContentLayout';
import { applyPaddings } from '@/utils/applyPaddings';

export type TTileBgOptioons = 'SkyBlue' | 'Navy' | 'Gray' | 'None';

type TileContainerProps = {
    bg?: TTileBgOptioons;
    className?: string;
    children: ReactNode;
    paddingTop?: string;
    paddingBottom?: string;
};

const TileContainer: FC<TileContainerProps> = ({
    bg = 'None',
    children,
    className,
    paddingTop,
    paddingBottom,
}) => (
    <div
        className={classNames(
            'tw-pt-20 tw-pb-12',
            {
                'tw-bg-bgSkyLight': bg === 'SkyBlue',
                'tw-bg-bgNavy': bg === 'Navy',
                'tw-bg-bgGray': bg === 'Gray',
            },
            className,
        )}
        style={applyPaddings({ paddingTop, paddingBottom })}
    >
        <ContentLayout>{children}</ContentLayout>
    </div>
);

export default TileContainer;
